/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { StreemApiAggregatedRoomMetricsFromJSON, StreemApiAggregatedRoomMetricsToJSON, } from './';
export function StreemApiAggregateRoomMetricsForCompanyResponseFromJSON(json) {
    return StreemApiAggregateRoomMetricsForCompanyResponseFromJSONTyped(json, false);
}
export function StreemApiAggregateRoomMetricsForCompanyResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'results': !exists(json, 'results') ? undefined : (json['results'].map(StreemApiAggregatedRoomMetricsFromJSON)),
        'totalSize': !exists(json, 'total_size') ? undefined : json['total_size'],
        'nextPageToken': !exists(json, 'next_page_token') ? undefined : json['next_page_token'],
    };
}
export function StreemApiAggregateRoomMetricsForCompanyResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'results': value.results === undefined ? undefined : (value.results.map(StreemApiAggregatedRoomMetricsToJSON)),
        'total_size': value.totalSize,
        'next_page_token': value.nextPageToken,
    };
}
//# sourceMappingURL=StreemApiAggregateRoomMetricsForCompanyResponse.js.map